import React, { useState } from "react";
import ReactFlagsSelect from "react-flags-select";
// import "react-flags-select/css/react-flags-select.css";

function Countryselect() {
  const [select, setSelect] = useState("US");

  // Mapping of country codes to URLs
  const countryUrls = {
    US: "https://dgiworx.com",
    IN: "https://dgiworx.in",
    AU: "https://dgiworx.com.au",
    CA: "https://dgiworx.ca"
  };

  const onSelect = (code) => {
    setSelect(code);
    // Redirect to the website based on selected country
   //window.location.href = countryUrls[code];
   // Get the current pathname
   const path = window.location.pathname;

   // Construct the new URL based on the selected country and the current pathname
   const newUrl = countryUrls[code] + path;

   // Redirect to the new URL
   window.location.href = newUrl;
  };

  const customLabels = {
    US: "US",
    CA: "CA",
    IN: "IN",
    AU: "AU",
  };

  return (
    <div>
      <ReactFlagsSelect
        selected={select}
        onSelect={onSelect}
        countries={["US", "CA", "IN", "AU"]}
        customLabels={customLabels}
      />
    </div>
  );
}

export default Countryselect;
